// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
@keyframes list-fill {
  0% {
    opacity: 0;
    transform: translateX(30%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes reverse-list-fill {
  0% {
    opacity: 0;
    transform: translateX(-30%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes page-transition-slide-in {
  from {
    transform: translateX(7.5rem);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes page-transition-reverse-slide-in {
  from {
    transform: translateX(-7.5rem);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes page-transition-slide-out {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-7.5rem);
  }
}
@keyframes width-grow {
  from {
    transform: scaleX(0.001);
  }
  to {
    transform: scaleX(1);
  }
}
@keyframes width-shrink {
  from {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0.001);
  }
}
@keyframes height-grow {
  from {
    transform: scaleY(0.0001);
  }
  to {
    transform: scaleY(1);
  }
}
@keyframes height-fade-and-grow {
  from {
    opacity: 0;
    transform: scaleY(0.0001);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}
@keyframes height-shrink {
  from {
    transform: scaleY(1);
  }
  to {
    transform: scaleY(0.001);
  }
}
@keyframes roll-in {
  from {
    opacity: 0;
    transform: translateX(10rem) rotate(500deg);
  }
  to {
    opacity: 1;
    transform: translateX(0) rotate(0);
  }
}
@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateX(5rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes slide-out {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-5rem);
  }
}
@keyframes drop {
  0% {
    transform: translateY(-1rem);
  }
  100% {
    transform: translateY(0);
  }
}
app-root .facilities-page ul.facilities {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}
app-root .facilities-page ul.facilities li {
  will-change: transform, opacity;
  animation: 0.3s ease-in-out normal backwards list-fill;
}
app-root .facilities-page ul.facilities li:nth-of-type(1) {
  animation-delay: 0s;
}
app-root .facilities-page ul.facilities li:nth-of-type(2) {
  animation-delay: 0.06s;
}
app-root .facilities-page ul.facilities li:nth-of-type(3) {
  animation-delay: 0.12s;
}
app-root .facilities-page ul.facilities li:nth-of-type(4) {
  animation-delay: 0.18s;
}
app-root .facilities-page ul.facilities li:nth-of-type(5) {
  animation-delay: 0.24s;
}
app-root .facilities-page ul.facilities li:nth-of-type(6) {
  animation-delay: 0.3s;
}
app-root .facilities-page ul.facilities li:nth-of-type(7) {
  animation-delay: 0.36s;
}
app-root .facilities-page ul.facilities li:nth-of-type(8) {
  animation-delay: 0.42s;
}
app-root .facilities-page ul.facilities li:nth-of-type(9) {
  animation-delay: 0.48s;
}
app-root .facilities-page ul.facilities li:nth-of-type(10) {
  animation-delay: 0.54s;
}
app-root .facilities-page ul.facilities li:nth-of-type(11) {
  animation-delay: 0.6s;
}
app-root .facilities-page ul.facilities li:nth-of-type(12) {
  animation-delay: 0.66s;
}
app-root .facilities-page ul.facilities li:nth-of-type(13) {
  animation-delay: 0.72s;
}
app-root .facilities-page ul.facilities li:nth-of-type(14) {
  animation-delay: 0.78s;
}
app-root .facilities-page ul.facilities li:nth-of-type(15) {
  animation-delay: 0.84s;
}
app-root .facilities-page.reverse-transitions ul.facilities li {
  animation-name: reverse-list-fill;
}
app-root .biz-flow .facilities-page section.catering {
  width: 100%;
  margin: 0 auto;
  margin-top: 24px;
  will-change: opacity;
  animation: fade-in 0.4s ease-in 0.15s backwards;
}
@media (min-width: 900px) {
  app-root .biz-flow .facilities-page section.catering {
    width: calc(100% - (2 * (100% - 128px) / 9));
  }
}
@media (min-width: 1151px) {
  app-root .biz-flow .facilities-page section.catering {
    width: calc(100% - (2 * (100% - 80px) / 6));
  }
}
app-root .biz-flow .facilities-page section.catering .hb-text-area,
app-root .biz-flow .facilities-page section.catering label {
  will-change: transform;
  animation: drop 0.2s ease-in-out 0.15s backwards;
}
app-root .biz-flow .facilities-page section.catering h3 {
  margin-bottom: 16px;
}
app-root .biz-flow .facilities-page section.catering .hb-text-area {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/utilities.less","webpack://./src/Views/FormSteps/Facilities/Biz/FacilitiesInput.less","webpack://./src/Styles/buttonList.less","webpack://./src/Styles/animations.less","webpack://./src/Styles/GridLayout/layoutHelpers.less","webpack://./src/Styles/textAreaSection.less"],"names":[],"mappings":"AA6BA;EAnBE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;ACRF;ACiBA;EACE;IACE,UAAA;IACA,0BAAA;EDfF;ECkBA;IACE,UAAA;IACA,wBAAA;EDhBF;AACF;ACmBA;EACE;IACE,UAAA;IACA,2BAAA;EDjBF;ECoBA;IACE,UAAA;IACA,wBAAA;EDlBF;AACF;AE3BE;EACE;IACE,UAAA;EF6BJ;EE1BE;IACE,UAAA;EF4BJ;AACF;AEzBE;EACE;IACE,UAAA;EF2BJ;EExBE;IACE,UAAA;EF0BJ;AACF;AEvBE;EACE;IACE,6BAAA;EFyBJ;EEtBE;IACE,wBAAA;EFwBJ;AACF;AErBE;EACE;IACE,8BAAA;EFuBJ;EEpBE;IACE,wBAAA;EFsBJ;AACF;AEnBE;EACE;IACE,wBAAA;EFqBJ;EElBE;IACE,8BAAA;EFoBJ;AACF;AEjBE;EACE;IACE,wBAAA;EFmBJ;EEhBE;IACE,oBAAA;EFkBJ;AACF;AEfE;EACE;IACE,oBAAA;EFiBJ;EEdE;IACE,wBAAA;EFgBJ;AACF;AEbE;EACE;IACE,yBAAA;EFeJ;EEZE;IACE,oBAAA;EFcJ;AACF;AEXE;EACE;IACE,UAAA;IACA,yBAAA;EFaJ;EEVE;IACE,UAAA;IACA,oBAAA;EFYJ;AACF;AETE;EACE;IACE,oBAAA;EFWJ;EERE;IACE,wBAAA;EFUJ;AACF;AEPE;EACE;IACE,UAAA;IACA,2CAAA;EFSJ;EEPE;IACE,UAAA;IACA,kCAAA;EFSJ;AACF;AENE;EACE;IACE,UAAA;IACA,2BAAA;EFQJ;EENE;IACE,UAAA;IACA,wBAAA;EFQJ;AACF;AELE;EACE;IACE,UAAA;IACA,2BAAA;EFOJ;EELE;IACE,UAAA;IACA,wBAAA;EFOJ;AACF;AEJE;EACE;IACE,UAAA;IACA,wBAAA;EFMJ;EEJE;IACE,UAAA;IACA,4BAAA;EFMJ;AACF;AEHE;EACE;IACE,4BAAA;EFKJ;EEFE;IACE,wBAAA;EFIJ;AACF;AA3JA;ECEM,aAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AD4JN;AAnKA;ECUQ,+BAAA;EACA,sDAAA;AD4JR;AD7EG;EACC,mBAAA;AC+EJ;ADhFG;EACC,sBAAA;ACkFJ;ADnFG;EACC,sBAAA;ACqFJ;ADtFG;EACC,sBAAA;ACwFJ;ADzFG;EACC,sBAAA;AC2FJ;AD5FG;EACC,qBAAA;AC8FJ;AD/FG;EACC,sBAAA;ACiGJ;ADlGG;EACC,sBAAA;ACoGJ;ADrGG;EACC,sBAAA;ACuGJ;ADxGG;EACC,sBAAA;AC0GJ;AD3GG;EACC,qBAAA;AC6GJ;AD9GG;EACC,sBAAA;ACgHJ;ADjHG;EACC,sBAAA;ACmHJ;ADpHG;EACC,sBAAA;ACsHJ;ADvHG;EACC,sBAAA;ACyHJ;ACpMK;EACC,iCAAA;ADsMN;AAvNA;EGqDE,WAAA;EACA,cAAA;EChDA,gBAAA;EAiBA,oBAAA;EACA,+CAAA;AJsMF;AG/JE;EAAA;IAGE,4CAAA;EHgKF;AACF;AG9JE;EAAA;IACE,2CAAA;EHiKF;AACF;AAxOA;;EI4BI,sBAAA;EACA,gDAAA;AJgNJ;AA7OA;EIcI,mBAAA;AJkOJ;AAhPA;EIiBI,WAAA;AJkOJ","sourcesContent":["@import './mediaQueries.less';\n@import './GridLayout/layoutHelpers.less';\n\n@pseudo-header-height: 64px;\n@progress-bar-height: 0.25rem;\n@body-gutter-width: 16px;\n@nav-height: calc(1.5rem + 47px);\n\n// styles for screen-reader only content\n.visually-hidden-content() {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.unset-visually-hidden-content() {\n  clip: unset;\n  clip-path: unset;\n  height: unset;\n  overflow: unset;\n  position: unset;\n  white-space: unset;\n  width: unset;\n}\n\n.visually-hidden {\n  .visually-hidden-content();\n}\n\n.fixed-full-width-content() {\n  margin: 0 -16px;\n  left: 16px;\n  width: 100%;\n  min-width: 320px;\n  position: fixed;\n}\n\n.wide-content() {\n  .main-content-width-rules(6);\n}\n.narrow-content() {\n  .main-content-width-rules(4);\n}\n\n// LF Overrides - the 'wide' content covers 2/3 of full width on large screens\n\n.wide-leadfeed-content() {\n  .wide-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8);\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(8, 10);\n  }\n  @media @largeDesktopUp {\n    .calc-column-width(6, 10);\n  }\n}\n.narrow-leadfeed-content() {\n  .narrow-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8) // same as wide content;\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(4, 10);\n  }\n}\n\n.fixed-two-third-width-content() {\n  .fixed-full-width-content();\n  @media @desktopUp {\n    width: 66%;\n  }\n}\n\n// For use within a 'wide' content container\n.nested-input() {\n  .nested-input-width-rules(6);\n}\n\n// For use within a 'wide' content container\n.nested-lf-input() {\n  .nested-input-width-rules(6,8);\n}\n\n// For delaying repeated animation on a list or group of matching elements\n.sequential-delay(@counter, @delay, @child-selector: ~'', @base-delay: 0) when (@counter > 0) {\n  .sequential-delay((@counter - 1), @delay, @child-selector, @base-delay); // next iteration\n\n  &:nth-of-type(@{counter})@{child-selector} {\n    animation-delay: (@base-delay + @delay * (@counter - 1)); // code for each iteration\n  }\n}\n","@import '../../../../Styles/buttonList.less';\n@import '../../../../Styles/textAreaSection.less';\n\napp-root {\n  .button-list-styles(facilities-page, facilities);\n\n  .biz-flow .facilities-page section.catering {\n    .textarea-section-styles('Biz');\n  }\n}\n","@import './utilities.less';\n\n.button-list-styles(@page-class, @list-class, @base-delay: 0 ) {\n  .@{page-class} {\n    ul.@{list-class} {\n      display: flex;\n      flex-grow: 0;\n      flex-shrink: 0;\n      flex-wrap: wrap;\n      justify-content: center;\n      gap: 16px;\n\n      li {\n        will-change: transform, opacity;\n        animation: 0.3s ease-in-out normal backwards list-fill;\n        .sequential-delay(15, 0.06s, ~'', @base-delay);\n      }\n    }\n\n    &.reverse-transitions ul.@{list-class} li {\n      animation-name: reverse-list-fill;\n    }\n  }\n}\n\n@keyframes list-fill {\n  0% {\n    opacity: 0;\n    transform: translateX((30%));\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX((0));\n  }\n}\n\n@keyframes reverse-list-fill {\n  0% {\n    opacity: 0;\n    transform: translateX((-30%));\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX((0));\n  }\n}\n","app-root {\n  @keyframes fade-in {\n    from {\n      opacity: 0;\n    }\n\n    to {\n      opacity: 1;\n    }\n  }\n\n  @keyframes fade-out {\n    from {\n      opacity: 1;\n    }\n\n    to {\n      opacity: 0;\n    }\n  }\n\n  @keyframes page-transition-slide-in {\n    from {\n      transform: translateX(7.5rem);\n    }\n\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes page-transition-reverse-slide-in {\n    from {\n      transform: translateX(-7.5rem);\n    }\n\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes page-transition-slide-out {\n    from {\n      transform: translateX(0);\n    }\n\n    to {\n      transform: translateX(-7.5rem);\n    }\n  }\n\n  @keyframes width-grow {\n    from {\n      transform: scaleX(0.001);\n    }\n\n    to {\n      transform: scaleX(1);\n    }\n  }\n\n  @keyframes width-shrink {\n    from {\n      transform: scaleX(1);\n    }\n\n    to {\n      transform: scaleX(0.001);\n    }\n  }\n\n  @keyframes height-grow {\n    from {\n      transform: scaleY(0.0001);\n    }\n\n    to {\n      transform: scaleY(1);\n    }\n  }\n\n  @keyframes height-fade-and-grow {\n    from {\n      opacity: 0;\n      transform: scaleY(0.0001);\n    }\n\n    to {\n      opacity: 1;\n      transform: scaleY(1);\n    }\n  }\n\n  @keyframes height-shrink {\n    from {\n      transform: scaleY(1);\n    }\n\n    to {\n      transform: scaleY(0.001);\n    }\n  }\n\n  @keyframes roll-in {\n    from {\n      opacity: 0;\n      transform: translateX(10rem) rotate(500deg);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0) rotate(0);\n    }\n  }\n\n  @keyframes slide-up {\n    from {\n      opacity: 0;\n      transform: translateY(5rem);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes slide-in {\n    from {\n      opacity: 0;\n      transform: translateX(5rem);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes slide-out {\n    from {\n      opacity: 1;\n      transform: translateX(0);\n    }\n    to {\n      opacity: 0;\n      transform: translateX(-5rem);\n    }\n  }\n\n  @keyframes drop {\n    0% {\n      transform: translateY(-1rem);\n    }\n\n    100% {\n      transform: translateY(0);\n    }\n  }\n}\n\n.cubic-slide-in-animation(@delay: 0s) {\n  animation: 0.25s ease-in normal backwards @delay fade-in,\n    0.3s cubic-bezier(0.39, 0.67, 0.61, 0.96) normal backwards @delay page-transition-slide-in;\n}\n.cubic-reverse-slide-in-animation(@delay: 0s) {\n  animation: 0.4s ease-in normal backwards @delay fade-in,\n    0.2s cubic-bezier(0.23, 0.06, 0.55, 0.42) normal backwards @delay\n      page-transition-reverse-slide-in;\n}\n.cubic-slide-out-animation(@delay: 0s) {\n  animation: 0.3s ease-in @delay forwards fade-out,\n    0.3s cubic-bezier(0.23, 0.06, 0.55, 0.42) @delay forwards page-transition-slide-out;\n}\n","@import '../mediaQueries.less';\n\n// These helpers are designed to replicate Product's 12-column design system.\n\n@columnGap: 16px;\n\n.calc-column-width(@columnCount, @totalColumns: 12) {\n  @combinedLayoutGaps: (@totalColumns - 1) * @columnGap;\n  @combinedElementGaps: (@columnCount - 1) * @columnGap;\n  // Delay computation until wrapped by CSS calc\n  @singleColumnWidth: ~'(100% - @{combinedLayoutGaps}) / @{totalColumns}';\n\n  width: calc(@columnCount * @singleColumnWidth + @combinedElementGaps);\n}\n\n// Centered content contained by a 'full width' parent (in LF layout, this is actually 2/3 screen)\n//\n// @columns - the width of the content in terms of number of grid columns at the largest screen size\n.main-content-width-rules(@columns) {\n  // For small screens, the content spans all of the available columns\n  margin: 0 auto;\n  max-width: 792px;\n\n  @media @landscapeTabletUp {\n    // For medium screens, the allocated columns are 50% higher.\n    // So a container spanning 6 columns on desktop spans 9 on tablet.\n    @responsiveColumns: round(@columns * 1.5);\n    .calc-column-width(@responsiveColumns);\n  }\n\n  @media @desktopUp {\n    .calc-column-width(@columns);\n  }\n}\n\n// Guard clause for case where @mediumDesktopParentColumns param is defined; see below documentaiton\n.nested-input-width-rules(@parentColumns, @mediumDesktopParentColumns: 0)\n  when\n  (\n    @mediumDesktopParentColumns > 0\n  ) {\n  @combinedParentGaps: (@mediumDesktopParentColumns - 1) * @columnGap;\n  // Delay computation until wrapped by CSS calc\n  @singleColumnWidth: ~'(100% - @{combinedParentGaps}) / @{mediumDesktopParentColumns}';\n  @media @mediumDesktopUp {\n    width: calc(100% - 2 * @singleColumnWidth);\n  }\n}\n\n// Centered content that is a child of a 'main-width' container as declared above.\n//\n// @parentColumns - the number of columns allocated to the container\n// @mediumDesktopPatentColumns - optional, the number of columns allocated to the container at\n//   medium-desktop breakpoints and up\n.nested-input-width-rules(@parentColumns, @mediumDesktopParentColumns: 0) {\n  // full width on small screens\n  width: 100%;\n  margin: 0 auto;\n\n  // drop 2 'columns' from the main-content parent width on larger screens\n\n  @responsiveColumns: @parentColumns;\n  @combinedParentGaps: (@responsiveColumns - 1) * @columnGap;\n  // Delay computation until wrapped by CSS calc\n  @singleColumnWidth: ~'(100% - @{combinedParentGaps}) / @{responsiveColumns}';\n\n  @media @landscapeTabletUp {\n    // see @responsiveColumns note above\n    @responsiveColumns: round(@parentColumns * 1.5);\n    width: calc(100% - (2 * @singleColumnWidth));\n  }\n\n  @media @desktopUp {\n    width: calc(100% - (2 * @singleColumnWidth));\n  }\n}\n","@import './utilities.less';\n@import './animations.less';\n\n.textarea-section-styles(@briefType: 'LF') when (@briefType = 'LF') {\n  .nested-lf-input();\n  margin-top: 24px;\n}\n.textarea-section-styles(@briefType: 'LF') when (@briefType = 'Biz') {\n  .nested-input();\n  margin-top: 24px;\n}\n\n.textarea-section-styles(@briefType: 'LF') {\n  // use within the section selector\n  .text-area-animation-styles();\n\n  h3 {\n    margin-bottom: 16px;\n  }\n  .hb-text-area {\n    width: 100%;\n  }\n}\n\n.text-area-animation-styles() {\n  // use within the section selector\n  will-change: opacity;\n  animation: fade-in 0.4s ease-in 0.15s backwards;\n\n  .hb-text-area,\n  label {\n    will-change: transform;\n    animation: drop 0.2s ease-in-out 0.15s backwards;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
